import { useRouter } from '#pplx/frontend/router/provider.js';
import { useCallback } from 'react';
function executeAssetAction(action, router) {
    switch (action.type) {
        case 'navigate':
            router.push(action.url);
            return;
        case 'external':
            window.open(action.url, '_blank', 'noopener,noreferrer');
            return;
        case 'callback':
            action.execute();
            return;
    }
}
export function useAssetAction() {
    const router = useRouter();
    return useCallback((actionDef) => executeAssetAction(actionDef.action, router), [router]);
}
//# sourceMappingURL=useAssetAction.js.map